// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPublicAddLegalAgreementV1Request {
  /** Тип согласия **/
  agreementType: string;
  /** Версия согласия **/
  agreementVersion: number;
  /** Принято согласие или нет **/
  status: EStatus;
  /** Источник согласия. Название экрана/команды/домена в произвольном виде **/
  source: string;
  /** Любые дополнительные данные специфичные для конкретного согласия **/
  additionalInfo?: TPublicAddLegalAgreementV1Request_AdditionalInfo;
}

export enum EStatus {
  /** Принял согласие **/
  'Accepted' = 'accepted',
  /** Отклонил согласие **/
  'Rejected' = 'rejected',
}
export type TPublicAddLegalAgreementV1Request_AdditionalInfo =
  null | TPublicAddLegalAgreementV1Request_AdditionalInfo_1;

export type TPublicAddLegalAgreementV1Request_AdditionalInfo_1 = object;
